
















































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import 'gridstack/dist/gridstack.min.css';
import { GridStack } from 'gridstack';
import 'gridstack/dist/h5/gridstack-dd-native';
import '../../node_modules/gridstack/dist/gridstack-extra.css';
import axios from 'axios';
import store from '../store';
import { Group } from '../models/Group';
import { Question } from '../models/Question';
import { Answer } from '../models/Answer';
import { MatrixScore } from '../models/MatrixScore';
import { Feedback } from '../models/Feedback';
import { UserData } from '../models/UserData';
import GridItemContent from '../components/GridItemContent.vue';
import html2canvas from 'html2canvas';
import { saveAs } from 'file-saver';
import { versions } from 'process';
import { use } from 'vue/types/umd';
const namespace: string = 'Grid';

@Component({
    components: {
        GridItemContent,
    },
})
export default class Grid extends Vue {
    private loadingGroups: boolean = true;
    private loadingQuestions: boolean = true;
    private loadingAnswers: boolean = true;
    private showError: boolean = false;
    private errorMessage: string = 'Error while loading groups.';
    private groups: Group[] = [];
    private selectedGroup: Group = this.groups[0];
    private selectedGroupId: number = 0;
    private completedGroups: Object[] = [false, false, false, false, false, false, false, false, false];
    private questions: Question[] = [];
    private showQuestionDialog: boolean = false;
    private questionStep: number = 1;
    private dialogTitle: String = 'Triple Impact Canvas';
    private showMenu: boolean = false;
    private select: string = '';
    private tempSelect: string = '';
    private checkbox: string[] = [];
    private answers: Answer[] = [];
    private versions: string[] = ['Current', 'Target'];
    private curVersion: string = 'Current';
    private newVersionName: string = '';
    private renameVersionName: string = '';
    private oldVersionName: string = '';
    private newVersionError: string = '';
    private showRenameDialog: boolean = false;
    private showNewVersionDialog: boolean = false;
    private showConfirmResetDialog: boolean = false;
    private feedback: Feedback[] = [];
    private grid: GridStack | null = null;
    private gridIds: string[] = [];
    private gridItems: GridItemContent[] = [];
    private faces: string[] = [];
    private targetGroup: string = '';
    private targetGroupMap: { [key: string]: number[] } = {
        'Consumers.': [37, 69, 70, 71, 72, 85],
        'Companies.': [37, 73, 74, 75, 85],
    }
    private personality: string = '';
    private personalityMap: { [key: string]: number[] } = {
        'We': [78, 80, 76, 63, 64, 65, 77],
        'Ego': [78, 80, 76, 66, 67, 68, 77],
    }
    private charLimitRule: { (v: string): boolean | string } [] = [
      v => v.length < 50 || 'test'
    ];

    private async initialize() {
        await this.getGroupsAsync();
        this.createGridItem(2, 8, 2, 0, 9);
        this.createGridItem(2, 5, 0, 3, 8);
        this.createGridItem(2, 3, 0, 0, 7);
        this.createGridItem(2, 5, 8, 3, 3);
        this.createGridItem(2, 6, 4, 0, 5);
        this.createGridItem(2, 6, 4, 6, 4);
        this.createGridItem(2, 8, 6, 0, 2);
        this.createGridItem(4, 4, 6, 8, 11);
        this.createGridItem(2, 3, 8, 0, 16);
        this.createGridItem(4, 4, 0, 8, 6);
    }

    mounted() {
        this.grid = GridStack.init({ column: 10, cellHeight: 65 });

        // Close dialog with 'esc' key
        document.addEventListener("keydown", (e) => {
            if (e.key === 'Escape' && this.showQuestionDialog === true) {
                this.showQuestionDialog = false;
                this.checkbox = [];
                this.showError = false;
                this.errorMessage = '';
            }
        });
    }

    private async createGridItem(width: number, height: number, xPos: number, yPos: number, id: number) {
        let group = this.groups.find(x => x.id === id);

        if (group === undefined) {
            return;
        }

        let instance = new GridItemContent();

        instance.cTitle = group.title;
        instance.cSubtitle = group.text;
        instance.cId = group.id;
        instance.cSortIndex = group.sortIndex;
        instance.cIcon = '/img/icons/' + group.title.toLowerCase().replace(/ /g, '') + '_neg.svg';
        instance.cBgColor = group.bgColor;
        instance.cFilter = group.iconFilter;

        let tempStringArr: string[][] = [];
        let tempImgArr: string[] = [];

        this.answers.filter(x => x.groupId === group!.id).forEach(x => {
            if (x.images && x.images.length) {
                x.images.forEach(image => tempImgArr.push(image));
            }
            else if (x.sortIndex === -1) {
                tempStringArr.push(x.answer);
            }
            else {
                tempStringArr[x.sortIndex] = x.answer;
            }
        });

        instance.cBody = tempStringArr;
        instance.cImages = tempImgArr;

        this.gridItems.push(instance);

        let div = document.createElement('div');
        div.id = Math.random().toString(24).substring(8);
        div.className = 'gridItemDiv';
        instance.$mount(div);

        let widget = this.grid!.addWidget({
            x: xPos,
            y: yPos,
            w: width,
            h: height,
            content: div.outerHTML
        });

        document.getElementById(div.id)!.appendChild(instance.$el)

        this.gridIds.push(div.id);

        document.getElementById(div.id)!.addEventListener("click", () => {
            this.getQuestionsAsync(group!);
        });
    }

    private async updateGridValues() {
        this.gridItems.forEach((item, index) => {
            let id: number = item.cId;
            let tempStringArr: string[][] = [];
            let tempImgArr: string[] = [];

            this.answers.forEach(x => {
                if (x.groupId == this.groups.find(x => x.id === id)?.id) {
                    if (x.images && x.images.length) {
                        x.images.forEach(image => tempImgArr.push(image))
                    }
                    else if (x.sortIndex === -1) {
                        tempStringArr.push(x.answer);
                    }
                    else {
                        tempStringArr[x.sortIndex] = x.answer;
                    }
                }
            });

            this.gridItems[index].cBody = tempStringArr;
            this.gridItems[index].cImages = tempImgArr;
        });
    }

    private async getGroupsAsync() {
        try {
            const response = await axios.get<Group[]>('api/groups');
            this.groups = response.data;
        } catch (e) {
            this.showError = true;
            if (e instanceof Error) {
                this.errorMessage = `Error while loading groups: ${e.message}.`;
            }
        }
        this.loadingGroups = false;
    }

    private async getQuestionsAsync(group: Group) {
        this.loadingQuestions = true;
        this.questionStep = 1;
        this.selectedGroup = group;
        this.selectedGroupId = group.id;
        this.dialogTitle = group.title;

        try {
            const response = await axios.get<Question[]>('api/questions?groupid=' + group.id);

            if (group.id === 9) {
                if (this.personality === '') {
                    this.questions = [];
                    throw new Error('Personality must be filled in before brand alliances');
                }
                else {
                    this.questions = response.data.filter(question => this.personalityMap[this.personality].includes(question.id));
                }
            }
            else {
                this.questions = response.data;
            }
        } catch (e) {
            this.showError = true;
            if (e instanceof Error) {
                this.errorMessage = `${e.message}.`;
            }
        }
        this.loadingQuestions = false;
        this.showQuestionDialog = true;
    }

    private submitQuestion(group: Group, question: Question, answer: string[], multiAnswer: string[]) {
        let matrixX = 0;
        let matrixY = 0;
        let matrixGroupId = -1;
        let multiAnswerStringArr: string[] = [];
        this.select = '';
        let images: string[] = [];

        // use multiAnswer if question is multichoice
        if (question.isMultiChoice) {
            multiAnswerStringArr = multiAnswer;
            if (this.tempSelect !== '') {
                if (this.tempSelect[this.tempSelect.length-1] !== '.') {
                    this.tempSelect += '.';
                }
                multiAnswerStringArr.push(this.tempSelect);
                this.tempSelect = '';
            }
            answer = multiAnswerStringArr;
            this.checkbox = [];
        }
        else {
            if (answer[0] === 'Other, specify.') {
                answer[0] = this.tempSelect;
                this.tempSelect = '';
            }
            else {
                this.tempSelect = '';
            }
        }

        //special cases
        if ([60, 61, 62].includes(question.id)) {
            const words = ['Personality', 'Feelings', 'Values'];

            let tempAnswer: string[] = [];
            tempAnswer[0] = words[question.id - 60] + ': ';
            answer.forEach((i, idx, array) => {
                if (array.length === 1) {
                    tempAnswer[0] += i + '.';
                }
                else if (idx === array.length - 1) {
                    tempAnswer[0] += 'and ' + i + '.';
                } else {
                    tempAnswer[0] += i + ', ';
                }
            });

            answer = tempAnswer;
        }

        if ([55, 20, 24, 29, 30, 32, 34, 44, 46, 47, 48, 49, 50, 63, 64, 65, 66, 67, 68, 70, 74, 76, 80].includes(question.id)) {
            let tempAnswer: string[] = [];
            let tempString: string = '';
            answer.forEach((i) => {
                tempString += i + ' ';
            });
            tempAnswer[0] = tempString;
            answer = tempAnswer;
        }

        if (question.id === 37) {
            this.targetGroup = answer[0];
            this.questions = this.questions.filter(x => this.targetGroupMap[this.targetGroup].includes(x.id));
        }

        // Get matrix values
        if (question.matrixGroup != null) {
            let optionIndex = question.options.findIndex((x) => x.text == answer[0]);
            if (optionIndex != -1) {
                matrixX = question.options[optionIndex].matrixXScore;
                matrixY = question.options[optionIndex].matrixYScore;
                matrixGroupId = question.matrixGroup.id;
            }
        }

        // check if answer is image
        if (question.isImage) {
            answer.forEach(text => {
                let temp = question.options.find(option => option.text === text);
                if (temp) {
                    images.push(temp.imageName);
                }
            });

            if (question.id === 53 && answer[0].length === 2) {
                images.push('/img/people/' + answer[0] + '.png')
            }
        }
        // special case to save space in vision
        if (question.id === 84 || question.id === 82) {
            let answerIndex = this.answers.findIndex((x) => x.groupId == group.id && x.questionId == question.id - 1);
            if (answerIndex !== -1) {
                this.answers[answerIndex]
                    = new Answer(group.id, this.answers[answerIndex].sortIndex, this.answers[answerIndex].questionId, this.answers[answerIndex].question + '/' + question.text, [this.answers[answerIndex].answer[0] + ' ' + answer[0]], images, matrixGroupId, matrixX, matrixY);
            }
        }
        // special case to save space in target group
        else if ([69, 70, 71, 72, 73, 74, 75].includes(question.id)) {
            let answerIndex = this.answers.findIndex((x) => x.groupId == group.id && x.questionId == 37);
            if (answerIndex !== -1) {
                this.answers[answerIndex]
                    = new Answer(group.id, this.answers[answerIndex].sortIndex, this.answers[answerIndex].questionId, this.answers[answerIndex].question + '/' + question.text, [this.answers[answerIndex].answer[0] + ' ' + answer[0]], images, matrixGroupId, matrixX, matrixY);
            }
        }
        else {
            // Check if question has answer
            let answerIndex = this.answers.findIndex((x) => x.groupId == group.id && x.questionId == question.id);
            if (answerIndex != -1) {
                this.answers[answerIndex]
                    = new Answer(group.id, question.sortIndex, question.id, question.text, answer, images, matrixGroupId, matrixX, matrixY);
            } else {
                this.answers = this.answers.concat([new Answer(group.id, question.sortIndex, question.id, question.text, answer, images, matrixGroupId, matrixX, matrixY)]);
            }
        }

        if (question.id === 21) {
            if (matrixX >=2 && matrixY >= 2) {
                this.faces = ['7A', '8A', '7B', '8B'];
            }
            else if (matrixX === 1 && matrixY >= 2) {
                this.faces = ['1A', '2A', '1B', '2B'];
            }
            else if (matrixX === 1 && matrixY < 2) {
                this.faces = ['3A', '4A', '3B', '4B'];
            }
            else if (matrixX > 1 && matrixY < 2) {
                this.faces = ['5A', '6A', '5B', '6B'];
            }

            if (matrixX === 1) {
                this.personality = 'Ego';
            } else {
                this.personality = 'We';
            }
        }
    }

    private completeForm(group: Group) {
        this.loadingAnswers = true;

        // Get all matrix answers
        let matrixGroupAnswers = this.answers.filter((x) => x.groupId == group.id && x.matrixGroupId != null);
        let matrixGroupScore: MatrixScore[] = [];

        // Calculate matrix values for each matrix group
        for (let index = 0; index < matrixGroupAnswers.length; index++) {
            let matrixGroupScoreId = matrixGroupScore.findIndex((x) => x.id == matrixGroupAnswers[index].matrixGroupId);
            if (matrixGroupScoreId != -1) {
                matrixGroupScore[matrixGroupScoreId].matrixX = matrixGroupScore[matrixGroupScoreId].matrixX + matrixGroupAnswers[index].matrixX;
                matrixGroupScore[matrixGroupScoreId].matrixY = matrixGroupScore[matrixGroupScoreId].matrixY + matrixGroupAnswers[index].matrixY;
                matrixGroupScore[matrixGroupScoreId].questions++;

            } else {
                matrixGroupScore = matrixGroupScore.concat([new MatrixScore(matrixGroupAnswers[index].matrixGroupId, matrixGroupAnswers[index].matrixX, matrixGroupAnswers[index].matrixY, 1)]);
            }
        }

        // Get feedback text for each matrix group
        for (let index = 0; index < matrixGroupScore.length; index++) {

            // Get matrix group
            const currentMatrix = group.matrixGroups.findIndex((x) => x.id === matrixGroupScore[index].id);
            let newFeedback: Feedback = new Feedback(-1, -1, '');

            if (currentMatrix !== -1) {

                let x = matrixGroupScore[index].matrixX / matrixGroupScore[index].questions;
                let y = matrixGroupScore[index].matrixY / matrixGroupScore[index].questions;

                // Round to closest 0.5
                x = Math.round(x * 2) / 2;
                y = Math.round(y * 2) / 2;

                if (y >= 2 && x <= 1) {
                    newFeedback = new Feedback(
                        group.id,
                        group.matrixGroups[currentMatrix].id,
                        group.matrixGroups[currentMatrix].feedback1,
                    );
                } else if (y >= 2 && x === 1.5) {
                    newFeedback = new Feedback(
                        group.id,
                        group.matrixGroups[currentMatrix].id,
                        group.matrixGroups[currentMatrix].feedback2,
                    );
                } else if (y >= 2 && x >= 2) {
                    newFeedback = new Feedback(
                        group.id,
                        group.matrixGroups[currentMatrix].id,
                        group.matrixGroups[currentMatrix].feedback3,
                    );
                } else if (y === 1.5 && x <= 1) {
                    newFeedback = new Feedback(
                        group.id,
                        group.matrixGroups[currentMatrix].id,
                        group.matrixGroups[currentMatrix].feedback4,
                    );
                } else if (y === 1.5 && x === 1.5) {
                    newFeedback = new Feedback(
                        group.id,
                        group.matrixGroups[currentMatrix].id,
                        group.matrixGroups[currentMatrix].feedback5,
                    );
                } else if (y === 1.5 && x >= 2) {
                    newFeedback = new Feedback(
                        group.id,
                        group.matrixGroups[currentMatrix].id,
                        group.matrixGroups[currentMatrix].feedback6,
                    );
                } else if (y <= 1 && x <= 1) {
                    newFeedback = new Feedback(
                        group.id,
                        group.matrixGroups[currentMatrix].id,
                        group.matrixGroups[currentMatrix].feedback7,
                    );
                } else if (y <= 1 && x === 1.5) {
                    newFeedback = new Feedback(
                        group.id,
                        group.matrixGroups[currentMatrix].id,
                        group.matrixGroups[currentMatrix].feedback8,
                    );
                } else if (y <= 1 && x >= 2) {
                    newFeedback = new Feedback(
                        group.id,
                        group.matrixGroups[currentMatrix].id,
                        group.matrixGroups[currentMatrix].feedback9,
                    );
                }

                // Replace or add new feedback
                if (newFeedback.groupId !== -1) {
                    const feedbackIndex = this.feedback.findIndex((i) => {
                        return i.matrixGroupId === group.matrixGroups[currentMatrix].id;
                    });
                    if (feedbackIndex !== -1) {
                        this.feedback[feedbackIndex] = newFeedback;
                    } else {
                        this.feedback = this.feedback.concat([newFeedback]);
                    }
                }
            }
        }

        // Complete group
        const completedGroupIndex = this.groups.findIndex((x) => x.id === group.id);
        if (completedGroupIndex !== -1) {
            this.completedGroups[completedGroupIndex] = true;
        }

        // Save user data
        const state: any = store.state;
        const userFromState = state.profile.user;

        let userData: any = {};

        if (userFromState.canvasData !== null) {
            userData = JSON.parse(userFromState.canvasData);
            userData[this.curVersion] = {
                answers: this.answers,
                completedGroups: this.completedGroups,
                personality: this.personality,
            };
        } else {
            userData = {
                [this.curVersion]: {
                    answers: this.answers,
                    completedGroups: this.completedGroups,
                    personality: this.personality,
                },
            };
        }

        this.updateUserDataAsync(new UserData(userFromState.id, JSON.stringify(userData)));
        store.commit('profile/profileDataUpdate', JSON.stringify(userData));

        // Stop loading - close dialog
        this.loadingAnswers = false;
        this.showQuestionDialog = false;

        // load new data
        this.updateGridValues();
    }

    private checkRadio(inputClass: string, inputId: string) {
        const boxes = document.getElementsByClassName(inputClass) as HTMLCollectionOf<HTMLInputElement>;

        for (const box of boxes) {
            if (box.id === inputId) {
                box.checked = true;
            } else {
                box.checked = false;
            }
        }

        this.checkbox = [];
    }

    private resetGroup(sGroup: Group) {
        this.answers = this.answers.filter((answer) => answer.groupId !== sGroup.id);

        if (sGroup.id === 4) {
            this.personality = '';
            this.resetGroup(this.groups.find((group) => group.id === 9)!);
        } else {
            const state: any = store.state;
            const userFromState = state.profile.user;

            let userData: any = {};

            if (userFromState.canvasData !== null) {
                userData = JSON.parse(userFromState.canvasData);
                userData[this.curVersion] = {
                    answers: this.answers,
                    completedGroups: this.completedGroups,
                    personality: this.personality,
                };
            } else {
                userData = {
                    [this.curVersion]: {
                        answers: this.answers,
                        completedGroups: this.completedGroups,
                        personality: this.personality,
                    },
                };
            }

            // Uncomplete group
            const completedGroupIndex = this.groups.findIndex((x) => x.id === sGroup.id);
            if (completedGroupIndex !== -1) {
                this.completedGroups[completedGroupIndex] = false;
            }

            this.updateUserDataAsync(new UserData(userFromState.id, JSON.stringify(userData)));
            store.commit('profile/profileDataUpdate', JSON.stringify(userData));
            this.showQuestionDialog = false;
            this.showConfirmResetDialog = false;
            this.updateGridValues();
        }
    }

    private getUserData() {
        const state: any = store.state;
        const userFromState = state.profile.user;

        if (userFromState.canvasData != null) {
            let userData = JSON.parse(userFromState.canvasData);



            if (userData == null || Object.keys(userData).length === 0) {
                userData = { Current: {}, Target: {} };
                this.updateUserDataAsync(userData);
                store.commit('profile/profileDataUpdate', JSON.stringify(userData));
            }

            this.versions = Object.keys(userData);
            const versionData = userData[this.curVersion];
            if (versionData !== null) {
                if (versionData.answers != null) {
                    this.answers = versionData.answers;
                }
                if (versionData.completedGroups != null) {
                    this.completedGroups = versionData.completedGroups;
                }
                if (versionData.personality != null) {
                    this.personality = versionData.personality;
                }
            }
        }

        this.updateGridValues();
    }

    private async updateUserDataAsync(item: UserData) {
        try {
            const response = await axios.put('api/ApplicationUsers/' + item.id, item);
            const result = response.data;
        } catch (e) {
            this.showError = true;
            if (e instanceof Error) {
                this.errorMessage = `Error while putting ApplicationUsers: ${e.message}.`;
            }
        }
    }

    private created() {
        this.initialize();
    }

    private printCanvas() {
        html2canvas(document.getElementById('mainGrid')!).then((canvas) => {
            canvas.toBlob((blob) => {
                saveAs(blob!, 'canvas.png');
            });
        });
    }

    private newVersion(newName: string) {
        if (!this.versions.includes(newName) && newName !== '') {
            this.versions.push(newName);
            this.curVersion = newName;

            this.answers = [];
            this.completedGroups = [false, false, false, false, false, false, false, false, false];
            this.personality = '';

            // Save user data
            const state: any = store.state;
            const userFromState = state.profile.user;

            let userData: any = {};

            if (userFromState.canvasData !== null) {
                userData = JSON.parse(userFromState.canvasData);
                userData[this.curVersion] = {
                    answers: this.answers,
                    completedGroups: this.completedGroups,
                    personality: this.personality,
                };
            } else {
                userData = {
                    [this.curVersion]: {
                        answers: this.answers,
                        completedGroups: this.completedGroups,
                        personality: this.personality,
                    },
                };
            }

            this.updateUserDataAsync(new UserData(userFromState.id, JSON.stringify(userData)));
            store.commit('profile/profileDataUpdate', JSON.stringify(userData));

            this.showNewVersionDialog = false;
            this.newVersionName = '';
            this.newVersionError = '';

            // load new data
            this.updateGridValues();
        } else {
            this.newVersionError = 'Name of new version needs to have a length of at least 1 and be unique.';
        }
    }

    private removeVersion(versionName: string) {
        if (this.curVersion === versionName) {
            this.curVersion = 'Current';
        }

        // Save user data
        const state: any = store.state;
        const userFromState = state.profile.user;

        let userData: any = {};

        if (userFromState.canvasData !== null) {
            userData = JSON.parse(userFromState.canvasData);
            if (userData[versionName] != null) {
                delete userData[versionName];
            }
        }

        this.updateUserDataAsync(new UserData(userFromState.id, JSON.stringify(userData)));

        store.commit('profile/profileDataUpdate', JSON.stringify(userData));

        // load new data
        this.getUserData();
    }

    private renameVersion(oldName: string, newName: string) {
        if (!this.versions.includes(newName)) {
            // Save user data
            const state: any = store.state;
            const userFromState = state.profile.user;

            let userData: any = {};

            if (userFromState.canvasData !== null) {
                userData = JSON.parse(userFromState.canvasData);
                delete Object.assign(userData, {[newName]: userData[oldName]})[oldName];
            }

            this.updateUserDataAsync(new UserData(userFromState.id, JSON.stringify(userData)));

            store.commit('profile/profileDataUpdate', JSON.stringify(userData));

            this.showRenameDialog = false;

            // load new data
            this.getUserData();
        }
    }

    private loadVersion(loadVersion: string) {
        this.curVersion = loadVersion;

        const state: any = store.state;
        const userFromState = state.profile.user;

        if (userFromState.canvasData != null) {
            const userData = JSON.parse(userFromState.canvasData);
            this.versions = Object.keys(userData);
            const versionData = userData[this.curVersion];
            if (versionData.answers != null) {
                this.answers = versionData.answers;
            }
            if (versionData.completedGroups != null) {
                this.completedGroups = versionData.completedGroups;
            }
            if (versionData.personality != null) {
                this.personality = versionData.personality;
            }
        }

        this.updateGridValues();
    }

}
